import React from "react";

const DIRS = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
const C = 200;

// Vastu directional compass mandala (rotating petals + fixed direction labels).
export default function VastuCompass({ className = "" }) {
  const gold = "rgba(212,175,55,0.6)";
  const green = "rgba(16,185,129,0.55)";
  return (
    <svg viewBox="0 0 400 400" className={className} aria-hidden="true" data-testid="vastu-compass">
      {/* Rotating mandala petals */}
      <g className="spin-med" style={{ transformOrigin: "200px 200px" }}>
        {Array.from({ length: 16 }).map((_, i) => {
          const a = i * 22.5;
          return (
            <g key={i} transform={`rotate(${a} 200 200)`}>
              <path d="M200 40 Q214 120 200 190 Q186 120 200 40 Z" fill="none" stroke={i % 2 ? green : gold} strokeWidth="0.7" opacity="0.55" />
            </g>
          );
        })}
        <circle cx={C} cy={C} r="150" fill="none" stroke={gold} strokeWidth="0.6" />
        <circle cx={C} cy={C} r="150" fill="none" stroke={green} strokeWidth="0.4" strokeDasharray="1 7" />
      </g>

      {/* Counter-rotating inner geometry (Sri-yantra-like triangles) */}
      <g className="spin-rev" style={{ transformOrigin: "200px 200px" }}>
        <polygon points="200,110 278,245 122,245" fill="none" stroke="rgba(56,189,248,0.4)" strokeWidth="0.7" />
        <polygon points="200,290 122,155 278,155" fill="none" stroke={gold} strokeWidth="0.7" />
        <circle cx={C} cy={C} r="70" fill="none" stroke={green} strokeWidth="0.6" />
      </g>

      {/* Fixed compass needle + direction labels */}
      <g>
        <circle cx={C} cy={C} r="188" fill="none" stroke={gold} strokeWidth="0.8" opacity="0.5" />
        <path d="M200 96 L212 200 L200 208 L188 200 Z" fill="rgba(212,175,55,0.85)" />
        <path d="M200 304 L212 200 L200 192 L188 200 Z" fill="rgba(226,232,240,0.35)" />
        <circle cx={C} cy={C} r="6" fill="#0A1128" stroke={gold} strokeWidth="1" />
        {DIRS.map((d, i) => {
          const a = ((i * 45 - 90) * Math.PI) / 180;
          const r = 176;
          return (
            <text key={d} x={C + r * Math.cos(a)} y={C + r * Math.sin(a)} fontSize={d.length > 1 ? "12" : "15"} fontWeight="600" textAnchor="middle" dominantBaseline="central" fill={i === 0 ? "#D4AF37" : "rgba(226,232,240,0.7)"} style={{ fontFamily: "Outfit, sans-serif" }}>
              {d}
            </text>
          );
        })}
      </g>
    </svg>
  );
}
